import Decimal from "decimal.js";

export function stringifyFields(obj: any) {
  return JSON.parse(
    JSON.stringify(obj, (key, value) => {
      if (value === null || value === undefined) {
        return undefined;
      }
      if (typeof value === "object" && "$numberDecimal" in value) {
        return new Decimal(value["$numberDecimal"]).toFixed();
      }
      if (typeof value === "string" && !isNaN(Date.parse(value))) {
        return {
          __type: "date",
          value: new Date(value).getTime(),
        };
      }
      return value;
    }),
    (_, value) => {
      if (value === null || value === undefined) {
        return undefined;
      }
      if (typeof value === "object" && value.__type === "date") {
        return new Date(value.value);
      }

      return value;
    }
  );
}
